module.exports = __webpack_public_path__ + "img/fashion_73.8448f4dc.jpg";